import aboutPictureA from '../images/icons_assets/MarioandAdrianA.jpg';
import aboutPictureB from '../images/icons_assets/MarioandAdrianB.jpg';

export const ABOUT = [
  {
    id: 1,
    title: 'Little Lemon',
    subtitle: 'Chicago',
    description:
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do ametsint. Velit officia consequat duis enim velit mollit. Exercitationveniam consequat sunt nostrud amet. Amet minim mollit non deseruntullamco est sit aliqua dolor do amet sint. Velit officia consequatduis enim velit mollit.',
    imageA: aboutPictureA,
    imageB: aboutPictureB,
  },
];
